import './toggle.less'

import {classes, Icon, m} from '@codeurs/front'
import {FiltersContext} from './filters'

export const Toggle = ({id, onclick, children, ...rest}) =>
	m(FiltersContext.Consumer, ({filter, style}) => {
		const active = filter.has(id)
		return m(`.toggle${style}`,
			m(`a.toggle${style}-link`,
				{
					onclick: e => {
						filter.toggle(id)
						if (onclick) onclick()
					},
					...rest,
					...classes({is: {active}})
				},
				m(`.toggle${style}-link-label`, children)
			)
		)
	})
